import { CategoryDto } from "../category/category.dto";

export class JobTypeDto extends CategoryDto {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-type/job-type.dto.ts